import { DEFAULT_ENVIRONMENT, setupEnvironment, setupKeycloak } from "@mds/common/constants/environment";
import axios from "axios";

export default function fetchEnv() {
  return axios
    .get(`${process.env.BASE_PATH}/env`)
    .then((res) => {
      try {
        JSON.parse(JSON.stringify(res.data));

        if (process.env.NODE_ENV === "development") {
          return DEFAULT_ENVIRONMENT;
        }
        return res.data;
      } catch (err) {
        return DEFAULT_ENVIRONMENT;
      }
    })
    .catch(() => DEFAULT_ENVIRONMENT)
    .then((env) => {
      setupEnvironment(
        env.apiUrl,
        env.docManUrl,
        env.filesystemProviderUrl,
        env.matomoUrl,
        env.environment,
        env.flagsmithKey,
        env.flagsmithUrl,
        env.flagsmithLocal,
        env.syncfusionLicense,
        env.geoMarkUrl
      );

      setupKeycloak(
        env.keycloak_clientId,
        env.keycloak_resource,
        env.keycloak_url,
        env.keycloak_idpHint,
        env.keycloak_bceid_idpHint || "na",
        env.keycloak_vcauthn_idpHint || "na",
        env.vcauthn_pres_req_conf_id || "na",
        env.siteminder_url || "na"
      );
    });
}
